import React from 'react';
// import {
//   Router,
//   Route,
// } from 'dva/router';
import {
  HashRouter,
  Route,
} from 'react-router-dom';
import App from './App';

function RouterConfig({ history, app }) {
  return (
    <HashRouter history={history}>
      <Route path="/" component={App} />
    </HashRouter>);
}

export default RouterConfig;
